import { render, staticRenderFns } from "./ClickReportTable.vue?vue&type=template&id=04065c9a"
import script from "./ClickReportTable.vue?vue&type=script&lang=js"
export * from "./ClickReportTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports